import {
  ApplicationRef,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  createComponent
} from '@angular/core';

import { LoaderOvelayComponent } from './loader-overlay.component';

type LoaderOptions = {
  message?: string;
};

class LoaderServiceResource {
  removeComponentFromBody<T = unknown>(
    appRef: ApplicationRef,
    component: ComponentRef<T>
  ): void {
    if (!component) {
      return;
    }

    appRef.detachView(component.hostView);
    component.destroy();

    component = undefined;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoaderOverlayService {
  private loaderComponentRef: ComponentRef<LoaderOvelayComponent>;

  private resource: LoaderServiceResource;

  constructor(private appRef: ApplicationRef) {
    if (!this.resource) {
      this.resource = new LoaderServiceResource();
    }
  }

  show({ message }: LoaderOptions = {}): void {
    if (this.loaderComponentRef) {
      return;
    }

    const componentFactory = createComponent(LoaderOvelayComponent, {
      environmentInjector: this.appRef.injector
    });

    componentFactory.instance.resource = {
      service: this,
      removeComponentFromBody: () =>
        this.resource.removeComponentFromBody(this.appRef, componentFactory)
    };

    if (message) {
      componentFactory.setInput('message', message);
    }

    this.appRef.attachView(componentFactory.hostView);
    const domElem = (
      componentFactory.hostView as EmbeddedViewRef<LoaderOvelayComponent>
    ).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    this.loaderComponentRef = componentFactory;

    this.loaderComponentRef.instance.show();
  }

  hide(): void {
    if (!this.loaderComponentRef) {
      return;
    }
    this.loaderComponentRef.instance.hide();
    this.loaderComponentRef = undefined;
  }
}
